// extracted by mini-css-extract-plugin
export default {"textClassName":"ycIrq","circleClassName":"OIIi8"};